import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Add some global styles for the profile page
import { CssBaseline } from '@mui/joy';

/* ===== FIX FOR material-react-table enableClickToCopy ===== */
if (!navigator.clipboard) {
  navigator.clipboard = {
    writeText: (text) =>
      new Promise((resolve) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        resolve();
      }),
  };
}
/* ========================================================== */

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>
);